import { Tooltip } from 'components';
import { taskIcons } from 'configs';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MemberCountBadge, StyledText, Wrapper } from './styled';

interface IconTextProps {
  icon: string;
  text: string;
  onClick?: () => void;
  memberCount?: number;
  memberNames?: string[];
}

const IconText: FC<IconTextProps> = ({ icon, text, onClick, memberCount }) => {
  const Icon = taskIcons[icon];
  const { t } = useTranslation();
  const renderMemberCountBadge = () => {
    if (memberCount === undefined || memberCount === 0) {
      return null;
    }

    const memberWord =
      memberCount === 1
        ? t('profileCommunities.titleMember')
        : t('common.member');
    const tooltipText = `${memberCount} ${memberWord}`;

    return (
      <Tooltip
        text={tooltipText}
        position="top-center"
        tooltipStyle={{
          fontSize: '12px',
          textAlign: 'center',
          maxWidth: '160px',
          whiteSpace: 'nowrap',
        }}
      >
        <MemberCountBadge>{memberCount}</MemberCountBadge>
      </Tooltip>
    );
  };

  return (
    <Wrapper onClick={onClick}>
      <Icon />
      <StyledText>{text}</StyledText>
      {renderMemberCountBadge()}
    </Wrapper>
  );
};

export default IconText;
